import { InputGroup, FormControl, Alert } from "react-bootstrap";
import leftIcon from "../assets/Icons/leftArrow.svg";
import { Footer } from "../components/include/Footer";
import Title from "../components/common/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isLoading,
  isError,
  isAuthenticated,
  isMessage,
  isData,
} from "../redux/selectors/authSelector";
import { login, loginClear, resetPasswordVerify } from "../redux/actions/authActions";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { message } from "../redux/actions/toastActions";
import Logo from "../assets/Icons/Frame 476.png";
import "../styles/Login.scss";
import emailIcon from "../assets/Icons/email.svg";
import lockIcon from "../assets/Icons/lock.svg";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";

const ResetPassword = () => {
  const [username, setusername] = useState(
    process.env.NODE_ENV !== "production" ? "devadmin" : ""
  );

  // Separate password states
  const [existingPassword, setExistingPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Separate show/hide states
  const [showExistingPassword, setShowExistingPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [remember, setremember] = useState(false);

  const loader = useSelector(isLoading);
  const Authenticated = useSelector(isAuthenticated);
  const loginMessage = useSelector(isMessage);
  const errorMsg = useSelector(isError);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const onLoginAction = (event) => {
    event.preventDefault();

    if ( !newPassword || !confirmPassword) {
      dispatch(message("All password fields are required."));
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("New password and confirm password do not match.");
      return;
    }

    console.log(
      username,

      existingPassword,
      newPassword,
      confirmPassword,
      " ----------"
    );

    // navigate("/sussess");

    dispatch(
      resetPasswordVerify(
        {
          email: location.state?.email || "",
          // password: existingPassword,
          new_password: newPassword,
        },
        () => {
          navigate("/sussess"); // redirect after success
          dispatch(message(loginMessage));
        }
      )
    );
  };

  useEffect(() => {
    dispatch(loginClear());
  }, []);

  return (
    <>
      <Title name="Reset Password" />
      <div
        className="account-pages loginBackground"
        style={{ paddingTop: "2%" }}
      >
        <div className="container">
          <div className="row justify-content-start">
            <div className="col-md-8 col-lg-6 col-xl-5">
              {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
              <div
                className="card overflow-hidden"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body pt-0">
                  <h3 className="text-center mt-4">
                    <a href="/" className="logo logo-admin">
                      <img src={Logo} height="100" alt="logo" className=" mb-4" style={{ width: "220px" }} />
                    </a>
                    <div className="d-flex align-items-center justify-content-start mt-3">
                      <img
                        src={leftIcon}
                        alt="logo"
                        onClick={() => navigate(-1)}
                        style={{ cursor: "pointer" }}
                      />
                      <h3 className="ps-5 ms-3 mb-0">Reset Password</h3>
                    </div>
                    {/* <p className="sub-title mt-2">
                      Please enter your current password, then choose and
                      confirm your new password to reset it securely.
                    </p> */}
                  </h3>

                  <div className="login-container">
                    <form className="login-form" onSubmit={onLoginAction}>
                      {/* Existing Password */}
                      {/* <label>
                        Existing Password<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={lockIcon} alt="lock" />
                        </span>
                        <input
                          type={showExistingPassword ? "text" : "password"}
                          value={existingPassword}
                          onChange={(e) => setExistingPassword(e.target.value)}
                          placeholder="Enter Your Existing Password"
                          autoComplete="current-password"
                        />
                        <span
                          className="toggle"
                          onClick={() =>
                            setShowExistingPassword(!showExistingPassword)
                          }
                        >
                          {showExistingPassword ? (
                            <IoEyeOffOutline className="icon" />
                          ) : (
                            <IoEyeOutline className="icon" />
                          )}
                        </span>
                      </div> */}

                      {/* New Password */}
                      <label>
                        New Password<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={lockIcon} alt="lock" />
                        </span>
                        <input
                          type={showNewPassword ? "text" : "password"}
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          placeholder="Enter Your New Password"
                          autoComplete="new-password"
                        />
                        <span
                          className="toggle"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                        >
                          {showNewPassword ? (
                            <IoEyeOffOutline className="icon" />
                          ) : (
                            <IoEyeOutline className="icon" />
                          )}
                        </span>
                      </div>

                      {/* Confirm Password */}
                      <label>
                        Confirm New Password<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon">
                          <img src={lockIcon} alt="lock" />
                        </span>
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          placeholder="Re-Enter New Password"
                          autoComplete="new-password"
                        />
                        <span
                          className="toggle"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                        >
                          {showConfirmPassword ? (
                            <IoEyeOffOutline className="icon" />
                          ) : (
                            <IoEyeOutline className="icon" />
                          )}
                        </span>
                      </div>

                      {/* Password Criteria */}
                      <div>
                        <p className="sub-title mb-0">
                          A Strong Password should contain:
                        </p>
                        <ul className="sub-title pl-0">
                          <li>8–12 characters</li>
                          <li>At least One Uppercase letter (A–Z)</li>
                          <li>At least One Lowercase letter (a–z)</li>
                          <li>At least One Number (0–9)</li>
                          <li>
                            At least One Special character (@, #, $, !, %, &, *)
                          </li>
                        </ul>
                      </div>

                      <button
                        type="submit"
                        className="sign-in-button"
                        disabled={loader}
                      >
                        {loader ? "Please wait..." : "Reset Password"}
                      </button>
                    </form>
                  </div>
                </div>
              </div>

              {/* Footer (optional) */}
              {/* <div className="mt-5 text-center"><Footer /></div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
